import { IApplicationState } from '../../types/redux';

export const getUser = (state: IApplicationState) => {
  return {
    userId: state.user.userId || undefined,
  };
};
